




































































































import { Component, Vue } from 'vue-property-decorator';
import '../assets/css/SubscriptionPlan.scss';
@Component({
    props: {
        selectedPlan: String,
        excludePlan: String,
        hideFreePlan: Boolean,
    },
})
export default class SubscriptionPlan extends Vue {
    private setSubscription(plan: string) {
        this.$emit('select', plan);
    }
}
